import { Box, Typography } from '@oresundsbron/bridge-ui';
import { FC } from 'react';
import type { ProviderInfo as Info } from './utils';
import { Trans, useTranslation } from 'next-i18next';
import { DefaultLink } from '~/components/Links/DefaultLink';
import { Information } from '@oresundsbron/icons';

interface ProviderInfoProps {
  info?: Info;
}

const ProviderStatus: FC<ProviderInfoProps> = ({ info }) => {
  const { t } = useTranslation('account');

  if (!info) {
    return null;
  }

  return (
    <Box
      className={'rounded bg-blue-200 px-4 py-4 text-blue-700 sm:px-6 sm:py-6'}
    >
      <Box className={'hidden flex-col gap-2 sm:flex'}>
        <Typography intent="title" weight="semibold">
          <Trans
            ns="account"
            i18nKey="dashboard.providerBanner.title"
            values={{
              issuer: info.issuer,
            }}
          ></Trans>
        </Typography>
        <Typography intent="body" weight="medium">
          {t(`dashboard.providerBanner.description`)}
        </Typography>
        <Typography intent="body" weight="bold">
          {t(`dashboard.providerBanner.link_text`)}
          <DefaultLink
            sx={{ color: 'colors.primary.600' }}
            href={info.link}
            weight="bold"
          >
            <Trans
              ns="account"
              i18nKey="dashboard.providerBanner.link"
              values={{
                issuer: info.issuer,
              }}
            ></Trans>
          </DefaultLink>
        </Typography>
      </Box>
      <Box className={'flex items-center gap-4 sm:hidden'}>
        <Box className="h-6 w-6">
          <Information height="24px" width="24px" />
        </Box>
        <Typography intent="body" weight="semibold">
          <Trans
            ns="account"
            i18nKey="dashboard.providerBanner.text_mobile"
            values={{
              issuer: info.issuer,
            }}
          ></Trans>
          <DefaultLink
            sx={{ color: 'colors.primary.600' }}
            href={info.link}
            weight="bold"
          >
            <Trans
              ns="account"
              i18nKey="dashboard.providerBanner.link"
              values={{
                issuer: info.issuer,
              }}
            ></Trans>
          </DefaultLink>
        </Typography>
      </Box>
    </Box>
  );
};

export default ProviderStatus;
